<template>
    <!-- TODO: On complete add success page -->
    <div class="py-10">
        <v-row>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.out_of_hours_contact_name"
                    :label="t('consultants::form.label.name')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.out_of_hours_contact_name"
                    mandatory
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.out_of_hours_contact_phone"
                    :label="t('consultants::form.label.phone')"
                    :rules="validationRules.out_of_hours_contact_phone"
                    :readonly="readOnlyRules"
                    mandatory
                ></b-input>
            </v-col>

            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.out_of_hours_contact_fax"
                    :label="t('consultants::form.label.fax')"
                    :rules="validationRules.out_of_hours_contact_fax"
                    :readonly="readOnlyRules"
                ></b-input>
            </v-col>

            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.out_of_hours_contact_email"
                    :label="t('consultants::form.label.email')"
                    :rules="validationRules.out_of_hours_contact_email"
                    :readonly="readOnlyRules"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            readOnlyRules: !this.can('api.v1.consultants.update') && this.can('api.v1.consultants.show'),
            validationRules: {
                out_of_hours_contact_name: [(v) => !!v || t('users::validation.field.required')],
                out_of_hours_contact_phone: [
                    (v) => !!v || t('users::validation.field.required'),
                    this.$root.rules.phone,
                ],
                out_of_hours_contact_fax: [this.$root.rules.fax],
                out_of_hours_contact_email: [
                    (v) => !!v || t('users::validation.field.required'),
                    this.$root.rules.email,
                ],
            },
        };
    },
    computed: {},
    methods: {},
};
</script>

<style></style>
